import { BaseAPI } from '../BaseApi';
import { eAPITags } from '../eAPITags';
import { ISettlementAgentResponse } from 'types/settlement-agents/ISettlementAgentResponse';

export const SettlementAgentsAPI = BaseAPI.injectEndpoints({
  endpoints: (build) => ({
    listSettlementAgents: build.query<ISettlementAgentResponse[], void>({
      query: () => `/timber/api/internal/settlement-agents`,
      providesTags: (result, error, request) => [{ type: eAPITags.SettlementAgents }],
    }),
  }),
  overrideExisting: false,
});

export const { useListSettlementAgentsQuery } = SettlementAgentsAPI;
